import React from "react";
import Typography from "@material-ui/core/Typography";
const Community = ({}) => {
  return (
    <React.Fragment>
      <Typography paragraph variant="h4">
        Invifo Community
      </Typography>
      <Typography paragraph variant="h5">
        Community Help.
      </Typography>
      <Typography paragraph variant="body1">
        Still stuck on a particular problem? The community is your first stop
        for questions and advice about the Invifo platform. Welcome to the
        community!
      </Typography>
    </React.Fragment>
  );
};

export default Community;
